<template>
  <v-layout wrap v-if="zones && zones.length > 0">
    <v-flex xs12 
      v-for="(item, index) of zones"
      :key="index"
    >
      <v-text-field
        v-model="item.XML"
        label="XML"
        outlined
        @input="handleChange"
      />
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: {
    player: {
      type: Object,
      default: null,
    },
    presentations: {
      type: Array,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    zones: []
  }),
  computed: {
    maintenance () {
      return '140181d0-aeff-11ed-9c29-f933aac7d201'
    },
  },
  watch: {
    'player.ID' () {
      this.prepareZones()
    },
    'player.Presentation' () {
      this.prepareZones()
    },
  },
  mounted () {
    this.prepareZones()
  },
  methods: {
    prepareZones () {
      const aux = this.presentations.filter(x => x.id === this.player.Presentation).shift()
      this.zones = []
      if (aux && aux.zones) {
        for ( let i = 0; i < aux.zones; i++) {
          const xml = this.player.Zones.filter(x => x.Zone === i).map(item => item.XML).shift()
          this.zones.push({ Zone: i, XML: xml ? xml : '' })
        }
        this.handleChange()
      }

    },
    handleChange () {
      this.onChange(this.zones)
    },
  },
}
</script>
